import { render } from "./HoldingOpening.vue?vue&type=template&id=b922d4da&scoped=true"
import script from "./HoldingOpening.vue?vue&type=script&lang=js"
export * from "./HoldingOpening.vue?vue&type=script&lang=js"

import "./HoldingOpening.vue?vue&type=style&index=0&id=b922d4da&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b922d4da"]])

export default __exports__